<template>
    <div>
        <v-card class="mt-6 pl-6 section">
            <v-card-title>
                <div class="text-h4 primary--text font-weight-light">Token List</div>
            </v-card-title>
            <v-card-text class="card">
                <v-col cols="8">
                    <v-row class="header-row">
                        <v-col cols="6" class="pt-0 pb-0">Description</v-col>
                        <v-col cols="6" class="pt-0 pb-0">Token </v-col>
                        <v-col cols="1" class="pt-0 pb-0"></v-col>
                    </v-row>
                </v-col>
                <v-row>
                    <v-col cols="8" class="pt-1 pb-0">
                        <v-row class="custom-row">
                            <v-col cols="12">
                                <v-row v-for="(item, index) in tablePricing" :key="index">
                                    <v-col cols="6" class="pl-2 pt-0 pb-0">
                                        <v-row style="width: 100%;" align="center" justify="center">
                                            <v-text-field :disabled="true" v-model="item.name" @input="updateTableDescription($event, item)">
                                            </v-text-field>
                                            <ClipboardComponent :text="item.name"/>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="6" class="pl-3 pt-0 pb-0">
                                        <v-row style="width: 100%;" align="center" justify="center">
                                            <v-text-field :disabled="true" v-model="item.token" @input="updateTablePrice($event, item)">
                                            </v-text-field>
                                            <ClipboardComponent :text="item.token"/>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <div class="custom-hr"></div>
                            </v-col>

                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>


    </div>
</template>

<script>

import ClipboardComponent from '../components/utilitycomps/ClipboardComponent.vue';
import { defaultTokenList } from '../store/global_helpers/utility';

export default {
    components:{
        ClipboardComponent,
    },

    data: () => ({
        tablePricing: defaultTokenList()

    }),
    methods:{
        async copyToClipboard(text){
            try{
                console.log("click")
                await navigator.clipboard.writeText(text)
            }catch(e){
                console.log(`error copying text`)
            }
        },
    }
}
</script>